const log = {
    invalid_type: 'Der Log Typ ist ungültig.',
    invalid_time_window: '`end_time` muss nach `start_time` liegen.',
};
export default Object.freeze(log);
